export default __webpack_public_path__ + "static/media/kitchen4-afterA-1920w.6ac61865.webp";